import { render, staticRenderFns } from "./SecretPrescriptionMngt.vue?vue&type=template&id=2ea88a8d&scoped=true"
import script from "./SecretPrescriptionMngt.vue?vue&type=script&lang=js"
export * from "./SecretPrescriptionMngt.vue?vue&type=script&lang=js"
import style0 from "./SecretPrescriptionMngt.vue?vue&type=style&index=0&id=2ea88a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea88a8d",
  null
  
)

export default component.exports